import React, { ForwardedRef, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Box, CircularProgress, Typography, Paper, Container } from '@mui/material';
import { toast } from 'react-toastify';
import ServiceAPI from '../../services/serviceapi';

const ConfirmacaoCadastro = React.forwardRef((_props: unknown, _ref: ForwardedRef<any>) => {
  const [hashConfirmacao, setHashConfirmacao] = useState<string | null>(null);
  const [carregando, setCarregando] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location?.search?.length > 0) {
      const raw = location.search;
      const cleanToken = raw.startsWith('?') ? raw.substring(1) : raw;
      setHashConfirmacao(cleanToken);
    }
  }, [location]);

  useEffect(() => {
    if (hashConfirmacao) {
      processarConfirmacao();
    }
  }, [hashConfirmacao]);

  const processarConfirmacao = async () => {
    try {
      const result = await ServiceAPI.consumeService({
        url: '/public/confirmarcadastro',
        data: hashConfirmacao,
        config: { ignoreToast: true }
      });

      if (result?.dataResponse) {
        toast.success('Cadastro confirmado com sucesso!');
        setTimeout(() => {
          navigate(`/login?xs=${result.dataResponse}`);
        }, 2000);
      } else {
        toast.error('Não foi possível confirmar o cadastro.');
      }
    } catch (error) {
      toast.error('Erro ao processar confirmação.');
    
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 12 }}>
      <Paper elevation={4} sx={{ p: 6, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Obrigado por se cadastrar!
        </Typography>
        {hashConfirmacao ?
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Estamos processando sua confirmação. Em instantes, você será redirecionado para a tela de login.
          </Typography>
          :
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Você recebeu um e-mail com um link de confirmação. Por favor, clique no link recebido para confirmar seu cadastro.
          </Typography>
        }
        <Box mt={4}>
          {carregando && <CircularProgress color="primary" />}
        </Box>
      </Paper>
    </Container>
  );
});

export default ConfirmacaoCadastro;
